import React from "react";
import styles from "../../assets/scss/componnetScss/header.module.scss"; // Ensure you have the SCSS file

const Hearder = ({ title, breadcrumb }) => {
  return (
    <>
      <section
        className={styles.banner}
        style={{ backgroundImage: `url("/images/header.png")` }}
      >
        <div className={styles.overlay}>
          <h1 className={styles.title}>{title}</h1>
          <span className={styles.arrow}>↓</span>
        </div>
      </section>

      <div className={styles.breadcrumbContainer}>
        <div className="container">
          <p className={styles.breadcrumb}>Home / {breadcrumb}</p>

        </div>
      </div>
    </>
  );
};

export default Hearder;
